import { render, staticRenderFns } from "./ProductContentDashboard.vue?vue&type=template&id=576ded82&scoped=true&"
import script from "./ProductContentDashboard.vue?vue&type=script&lang=js&"
export * from "./ProductContentDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ProductContentDashboard.vue?vue&type=style&index=0&id=576ded82&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "576ded82",
  null
  
)

export default component.exports